import { SaTravelExpenseSnapshot } from '@/components/Approval/@components/SaTravelExpense';
import { parseSaTravelExpenseContent } from '@/utils/approval/saTravelExpense';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 177 SA 신규 출장비 정산 — 저장 content 그대로(레거시 조회와 동일) */
const SaTravelExpenseSlot = ({ data }: ContentExtraProps) => {
  const content = parseSaTravelExpenseContent(data.attributes);
  if (!content) return null;
  return (
    <ContentSlotRoot>
      <SaTravelExpenseSnapshot content={content} />
    </ContentSlotRoot>
  );
};

export default SaTravelExpenseSlot;
